import React from "react";
import "./index.scss";
const NoItem = () => {
	return (
		<>
			<div className="no-item-blc text-center">
				{'No record found'}
			</div>
		</>
	);
}

export default NoItem;